var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70703 6.30957L7.54293 8.20017C8.55063 8.87197 9.86343 8.87197 10.8711 8.20017L13.707 6.30957M4.70703 16.0596H13.707C15.3639 16.0596 16.707 14.7164 16.707 13.0596V5.55957C16.707 3.90272 15.3639 2.55957 13.707 2.55957H4.70703C3.05018 2.55957 1.70703 3.90272 1.70703 5.55957V13.0596C1.70703 14.7164 3.05018 16.0596 4.70703 16.0596Z",
    stroke: "#A461D8",
    strokeWidth: 1.22727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2229b34a5fdd042feaf6509bf079abf7.svg";
export { ForwardRef as ReactComponent };